/**
 * Number of `currency` units for 1 euro: divide an amount by it to get euros.
 * Shopify order totals are in the shop currency, so one rate per shop is enough.
 * Rates are stored in the exchangeRate model, one official rate per currency.
 * Falls back to 1 (amount displayed unconverted) when no rate is stored or the query fails.
 * @param {object} api Gadget API client
 * @param {string} currency ISO 4217 code
 */
export const fetchEuroRate = async (api, currency) => {
  if (!currency || currency.toUpperCase() === "EUR") {
    return 1;
  }

  try {
    const exchangeRate = await api.exchangeRate.maybeFindFirst({
      filter: { currency: { equals: currency.toUpperCase() } },
      select: { unitsPerEuro: true },
    });
    if (exchangeRate?.unitsPerEuro > 0) {
      return exchangeRate.unitsPerEuro;
    }
  } catch (error) {
    console.error(`Failed to fetch exchange rate for ${currency}: ${error.message}`);
    return 1;
  }
  console.warn(`No exchange rate stored for currency ${currency}`);
  return 1;
};
